import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M15.4 5.3 8.7.4c-.4-.3-1-.3-1.4 0L.6 5.3c-.3.2-.4.5-.3.8s.4.4.7.4h.5V13c-.6 0-1 .4-1 1v1.1c0 .5.5 1 1 1h13c.5 0 1-.4 1-.9V14c0-.6-.4-1-1-1V6.5h.5c.3.1.7-.2.7-.5.1-.3-.1-.6-.3-.7M7.9 1.2h.2L14 5.5H2zM10.5 13h-2V6.5h2zm-5 0V6.5h2V13zm-3-6.5h2V13h-2zm12 8.5-13 .1V14h13zm-1-2h-2V6.5h2z" />
  </svg>
);
const SvgBuildingNext = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="building-next" {...props} />;
export default SvgBuildingNext;
